import React from 'react';
import Carousel from 'react-material-ui-carousel'
import { Paper, Button } from '@material-ui/core';
import './sample.css';
import imz from "../imgz/lastGIF.gif";
import zbnj from "../imgz/zabinji dp done.png"
import zanex from "../imgz/cryptozanex done.png"
import kiveng from "../imgz/kivengi.jpg"
import gama from "../imgz/gamaz.jpg"

function Sample(props)
{
    var items = [
        {
            name: "ZBN architecture",
            description: "kwakweli binafsi sijawahi kupata website kama hii kwa bei kama hii kabiisa ",
            src: zbnj,
        },
        {
            name: "CryptoZanex",
            description: "mindzwebsites mmeleta kitu kipya saana, website yangu imenyoka kuliko nlivotarajia",
            src: zanex,
        },
        {
            name: "Dr.Kivengi Jr",
            description:"nashukuru sana mindzwebsites kwa kitu makini, namim nmeingia kweye technology ",
            src: kiveng,
        },
        {
            name: "Deogratius Gama",
            description: "mindzwebsites kwakweli vitu vyenu sikutarajia kabisa",
            src: gama,
        }



    ]

    return (
        <Carousel>
            {
                items.map( (item, i) => <Item key={i} item={item} /> )
     
            }
        </Carousel>

            
    )
}

function Item(props)
{
    return (
        <Paper style={{backgroundColor: "unset",}}>
               <div className="ban">
                <div className="imeji">
                    <img src={props.item.src} alt="" className="imgz" />
                </div>
                <h1 className="jina">{props.item.name}</h1>
                <p className="sifa">"{props.item.description}"</p>
            </div>
     
        </Paper>
    )
}

export default Sample 